import { useEffect, useState } from "react";
import { CardSection } from "../../../components/CardSection";
import { StyledSection5 } from "./style";
import { Util } from "../../../util/Util";
import { API } from "../../../apis/dashboard.api";
import { BarGraph } from "../../../components/Graph/BarGraph";

import useRegionStore from "../../../store/useRegionStore";
import useDateRangeStore from "../../../store/useDateRangeStore";
import useLoadingStore from "../../../store/useLoadingState";
import { ALL_REGIONS, REGIONS } from "../../../consts/const";

export const Section5 = () => {
  const { selectedRegionList } = useRegionStore();
  const { periodStartDate, periodEndDate } = useDateRangeStore();
  const { setIsLoading } = useLoadingStore();
  const [statisticData, setStatisticData] = useState();

  const DEFAULT_DEVICE_DATA = [
    {
      deviceName: "1번기기",
      totalPthCnt: 0,
      repairedPthCnt: 0,
      inspectedCnt: 0,
      detectedPthCnt: 0,
    },
    {
      deviceName: "2번기기",
      totalPthCnt: 0,
      repairedPthCnt: 0,
      inspectedCnt: 0,
      detectedPthCnt: 0,
    },
  ];

  const getData = async () => {
    try {
      let convertData = {};

      for (let region of ALL_REGIONS) {
        if (selectedRegionList.includes(region.value)) {
          convertData = {
            ...convertData,
            [region.label]: DEFAULT_DEVICE_DATA,
          };
        }
      }

      setIsLoading(true, "LOADING...");
      const result = await API.getStatsticDevice({
        startDate: Util.formatDate(periodStartDate),
        endDate: Util.formatDate(periodEndDate),
        departmentIds: selectedRegionList,
      });

      if (await result) {
        for (let data of result) {
          let [department, device] = data.departmentSeq.split("-");
          const departmentName = department.replace("국토관리사무소", "");
          const deviceName = `${device}번기기`;

          convertData = {
            ...convertData,
            [departmentName]: Util.mergeArrays(
              convertData[departmentName],
              [
                {
                  deviceName: deviceName,
                  totalPthCnt: data.totalPthCnt,
                  repairedPthCnt: data.repairedPthCnt,
                  inspectedCnt: data.inspectedCnt,
                  detectedPthCnt: data.detectedPthCnt,
                },
              ],
              "deviceName"
            ),
          };
        }
        setStatisticData(convertData);
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedRegionList) getData();
  }, [selectedRegionList, periodStartDate, periodEndDate]);

  return (
    <StyledSection5>
      <div
        className="section5-container"
        style={{
          padding: !Object.keys(statisticData || {}).length ? "0" : "",
        }}
      >
        {Object.keys(statisticData || {}).length > 0 && (
          <CardSection title="기기별 데이터 검수 현황" icon="Histogram">
            <BarGraph
              data={statisticData}
              xKey="deviceName"
              yKey={[
                { label: "검수된 포트홀", key: "inspectedCnt" },
                { label: "검출된 포트홀", key: "detectedPthCnt" },
                { label: "보수된 포트홀", key: "repairedPthCnt" },
              ]}
              multiGraphMode={true}
              showLabels={true}
            />
          </CardSection>
        )}
      </div>
    </StyledSection5>
  );
};
